import React from "react";
import { motion } from "framer-motion";
import { BOXES, ORDER_LINKS } from "../data/menu";
import { Plus } from "lucide-react";

export const Boxes = () => {
  return (
    <section id="boxes" className="relative py-20 sm:py-32 bg-[#FFF0F3] overflow-hidden">
      <div aria-hidden className="absolute -top-32 right-0 h-[420px] w-[420px] rounded-full bg-[#FFE7BE] blur-3xl opacity-70" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5">
          <p className="font-script text-[#FF6392] text-3xl -rotate-2 inline-block">build your own,</p>
          <h2 className="font-serif-display text-3xl sm:text-5xl lg:text-6xl text-[#2D2327] tracking-tight mt-2">
            A box for every <span className="italic text-[#FF6392]">mood.</span>
          </h2>
          <p className="mt-6 text-base sm:text-lg text-[#4A3F44] max-w-md">
            Mix and match any donuts in the case. Pick four for a treat, nine for the team —
            the Special Box is the classic combo that started it all.
          </p>
          <a
            href={ORDER_LINKS.orderOnline}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="boxes-build-now"
            className="mt-8 inline-flex w-full sm:w-auto justify-center items-center gap-2 rounded-full bg-[#2D2327] text-white px-7 py-3.5 font-semibold hover:bg-[#FF6392] transition-colors"
          >
            <Plus className="h-4 w-4" /> Build a box
          </a>
        </div>

        <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-5">
          {BOXES.map((b, i) => (
            <motion.div
              key={b.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              data-testid={`box-${b.count}-card`}
              className="group relative bg-white rounded-3xl p-5 sm:p-7 border border-[#FFB3C6]/40 hover:border-[#FF6392] transition-colors lift"
            >
              <div className="flex items-center justify-between">
                <h3 className="font-serif-display text-2xl sm:text-3xl text-[#2D2327]">{b.name}</h3>
                <span className="font-serif-display text-2xl text-[#FF6392]">{b.price}</span>
              </div>
              <p className="mt-3 text-[#4A3F44]">{b.desc}</p>
              <div className="mt-5 grid grid-cols-9 gap-1.5">
                {Array.from({ length: 9 }).map((_, idx) => (
                  <span
                    key={idx}
                    className={`h-2 rounded-full ${
                      idx < b.count ? "bg-[#FF6392]" : "bg-[#FFB3C6]/40"
                    }`}
                  />
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Boxes;
